import { render, staticRenderFns } from "./SwiperImgs.vue?vue&type=template&id=0c26ea0a&scoped=true"
import script from "./SwiperImgs.vue?vue&type=script&lang=js"
export * from "./SwiperImgs.vue?vue&type=script&lang=js"
import style0 from "./SwiperImgs.vue?vue&type=style&index=0&id=0c26ea0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26ea0a",
  null
  
)

export default component.exports